import { Button } from '@mui/material'
import React from 'react'
import { StyledTextField } from '../../../../styles/common/UIComponents'
import { FlexContainer } from '../../../../styles/common/FlexBox'

const Unifecaf = () => {
    return (
        <FlexContainer direction="column" justify="center" align="center" gap="0.5rem" margin="0 0 1rem 0">
        <StyledTextField id="outlined-basic" label="Login" variant="outlined"/>
        <StyledTextField id="outlined-basic" label="Projeto" variant="outlined"/>
        <StyledTextField id="outlined-basic" label="Senha" variant="outlined"/>
        <Button variant="outlined">Entrar</Button>
        </FlexContainer>
    )
}

export default Unifecaf;